import SubscriptionOpeningDays from "../../enums/subscription/subscription_opening/SubscriptionOpeningDays";
import SubscriptionOpeningHours from "./subscription_opening/SubscriptionOpeningHours";

export default class SubscriptionOpening {
  private _days: SubscriptionOpeningDays;
  private _hours: SubscriptionOpeningHours; // NOTE : In Firestore this object is a two entry array

  constructor(days: SubscriptionOpeningDays, hours: SubscriptionOpeningHours) {
    this._days = days;
    this._hours = hours;
  }

  get days(): SubscriptionOpeningDays {
    return this._days;
  }

  get hours(): SubscriptionOpeningHours {
    return this._hours;
  }

  public copyWith({
    days,
    hours,
  }: {
    days?: SubscriptionOpeningDays;
    hours?: SubscriptionOpeningHours;
  }): SubscriptionOpening {
    return new SubscriptionOpening(days ?? this._days, hours ?? this._hours);
  }

  static fromFirestoreMap(data: Record<string, any>): SubscriptionOpening {
    return new SubscriptionOpening(
      data.days,
      SubscriptionOpeningHours.fromFirestoreArray(data.hours)
    );
  }

  toFirestoreMapPatch(): Record<string, any> {
    return {
      days: this._days,
      hours: this._hours.toFirestoreArrayPatch(),
    };
  }
}
